
// productObject = object provided my shopify or Fusion
// Make sure to have the object be at the prodct level object if on fusion
export const updateUrlParams = (productObject) => {

    // TODO look into how we can prevent 3rd party vendor calls
    // TODO - this is making attentive fire everytime hitting on performance

        // update url param
        window.history.pushState("", "", `/products/${productObject.handle}`);
        document.title = productObject.title
}

export const updateMobilePdpView = () => {
    if(window.innerWidth <= 900 && window.fusionDataLayer.activeSlider) {
        window.fusionElements.pdpMobileSlider.go('=0')
    window.scrollTo(0, 0);
    } else {
        return;
    }
}